/* eslint-env jquery */
require('slick-carousel-latest');

(function ($, w) {
  const initSlick = () => {

    if ($('[data-slick]').length) {
      $('[data-slick]')
        .not('.bs-slider-accordion-slick')
        .not('.slick-initialized')
        .slick();
    }
  };

  const debounce = ( func, wait ) => {
    let timer;
    return ( event ) => {
      if ( timer ) clearTimeout( timer );
      timer = setTimeout( func, wait, event );
    };
  };

  // To refresh the initiated slick sliders
  const refreshSlick = () => {
    $('.slick-initialized').each(function (key) {
      if (
        $('.slick-initialized')[key] &&
        $('.slick-initialized')[key].slick
      ) {
        $('.slick-initialized')[key].slick.refresh();
      }
    });
  };

  const debouncedHandlers = () => {
    initSlick();
    refreshSlick();
  };

  // Calls when the window is fully loaded
  $(w).on('load', () => {
    initSlick();
  });

  // Calls on window resize
  $(w).on('resize', debounce(debouncedHandlers, 300));
})(jQuery, window);
